import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "beru-card-badges" }
const _hoisted_2 = {
  key: 0,
  class: "beru-card-badge success",
  "data-qa": "beru-card-badge-cost"
}
const _hoisted_3 = {
  key: 1,
  class: "beru-card-badge success",
  "data-qa": "beru-card-badge-cost-rd"
}
const _hoisted_4 = {
  class: "copy-btn",
  type: "button",
  "data-qa": "beru-card-button-copy-number"
}
const _hoisted_5 = { class: "beru-card-row" }
const _hoisted_6 = {
  key: 0,
  class: "beru-card-title",
  "data-qa": "beru-card-value-date"
}
const _hoisted_7 = {
  key: 1,
  class: "beru-card-interval",
  "data-qa": "beru-card-value-interval"
}
const _hoisted_8 = { key: 0 }

import store from "@/store";
import { BeruCardFree, BeruCardTaken } from "@/types/beru";
import { copyText } from "@/utils/main";
import { addHours, format } from "date-fns";
import ru from "date-fns/locale/ru";
import { computed } from "vue";
import { POSITION, useToast } from "vue-toastification";

interface Props {
  card: BeruCardFree | BeruCardTaken;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaBeruCard',
  props: {
    card: {}
  },
  setup(__props: any) {

const props = __props;
const toast = useToast();

const isCardExchangeFree = (card: BeruCardFree | BeruCardTaken): card is BeruCardFree =>
  'startTime' in card;

const startTime = computed(() =>
  isCardExchangeFree(props.card) ? props.card.startTime : props.card.dateFrom
);
const endTime = computed(() =>
  isCardExchangeFree(props.card) ? props.card.endTime : props.card.dateTo
);

const onCopyClick = (value: string | number | null) => {
  copyText(value);
  toast.success("Сохранено в буфер обмена", {
    position: POSITION.BOTTOM_RIGHT
  });
};

const pharmTz = computed<number>(() => {
  return store.getters["data/pharmTz"] || 0;
});

// Получаем дату и время с учётом смещения таймзоны аптеки
const toPharmDate = (iso: string): Date => {
  const timeZone = pharmTz.value + new Date().getTimezoneOffset() / 60;
  return addHours(new Date(iso), timeZone);
};

const formatDateTime = (iso: string): string => format(toPharmDate(iso), 'd MMMM yyyy', { locale: ru });

const formatTime = (iso: string): string => format(toPharmDate(iso), "HH:mm");

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["beru-card", {'is-canceled': __props.card.armZortCanceledAt}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.card.shiftCost)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " +" + _toDisplayString(__props.card.shiftCost), 1))
        : _createCommentVNode("", true),
      (__props.card.shiftCostRD)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " ~РД " + _toDisplayString(__props.card.shiftCostRD), 1))
        : _createCommentVNode("", true),
      (__props.card.serialNumber)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "beru-card-badge primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onCopyClick(__props.card.serialNumber)), ["stop"])),
            "data-qa": "beru-card-badge-copy-number"
          }, [
            _createElementVNode("span", null, "№ " + _toDisplayString(__props.card.serialNumber), 1),
            _createElementVNode("button", _hoisted_4, [
              _createVNode(_component_vita_icon, { name: "copy" })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        (startTime.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(formatDateTime(startTime.value)), 1))
          : _createCommentVNode("", true),
        (startTime.value && endTime.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(formatTime(startTime.value)) + " - " + _toDisplayString(formatTime(endTime.value)), 1))
          : _createCommentVNode("", true)
      ]),
      (__props.card.armZortCanceledAt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", {
              class: "beru-card-status",
              "data-qa": "beru-card-status-canceled"
            }, "Отменена", -1)
          ]))]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})